import { Tracking } from "@omni/ui/components/CallToAction/types/tracking.types";
import { isDefined } from "@omni/utils/helper.utils";

export type TrackingProperties = {
    "data-tracking-event": string;
    "data-tracking-info": string;
};

export const createTrackingProperties = (
    trackingType: "click" | "impression",
    tracking?: Tracking
): TrackingProperties | undefined => {
    if (!isDefined(tracking)) return;

    const { clickEvent, impressionEvent, info } = tracking;

    return trackingType === "click"
        ? {
              "data-tracking-event": clickEvent,
              "data-tracking-info": info
          }
        : {
              "data-tracking-event": impressionEvent,
              "data-tracking-info": info
          };
};
